import $ from 'jquery';

export function resizeCards(target, bottomSupplementaire)
{
    var maxHeightCard = 0;

    $(target).each(function (index, element) {
        $(element).css('height', 'auto');
    });

    $(target).each(function (index, element) {
        var cardHeight = $(element).height();
        if (cardHeight > maxHeightCard) {
            maxHeightCard = cardHeight;
        }
    });

    $(target).each(function (index, element) {
        $(element).css('height', maxHeightCard + bottomSupplementaire);
    });
}

$(document).ready(function () {
    var target = '.containCartesAccessoires .greyCard';
    resizeCards(target, 50);
});

$(window).resize(function () {
    var target = '.containCartesAccessoires .greyCard';
    resizeCards(target, 50);
});
